// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_pMIRk {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    /* overflow-y: auto; */
    /* overflow-x: hidden; */
    /* background: var(--f5-background); */
    /* border-radius: 8px ; */
    /* padding: 10px; */
    /* overflow: hidden; */
    background: transparent !important;
    border-radius: 8px !important;
    padding: 0px !important;



    &::-webkit-scrollbar {
        display: none;
    }
}

.chat_kYIvt {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    gap: 10px;
    background: var(--fa-background);
    height: fit-content;
    overflow: hidden;
    padding: 10px;
    border-radius: 10px;

    &.transparent_sMqBU {
        border-radius: 0px !important;
        padding: 0px !important;
        background: transparent !important;
    }

}

.scrap_ROK0d {
    background-color: var(--f5-background);
    border-radius: 10px;
    padding: 4px 8px;


    h1 {
        font-size: 14px;
        font-weight: 600;
        color: #000;
    }

    .scrap_input_Z2vD8 {
        width: 100%;
        height: 40px;
        display: inline-flex;
        align-items: center;
        gap: 10px;

        input {
            width: 100%;
            /* height: 40px; */
            border: none;
            outline: none;
            padding: 6px;
            font-size: 16px;
            font-weight: 500;
        }

        button {
            cursor: pointer;
            width: 30px;
            height: 30px;
            background-color: #10a37f;
            border-radius: 10px;
            padding: 10px;
            border: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;

            svg {
                width: 12px;
                height: 14px;
            }
        }
    }
}


.info_XSDc8 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .info_img_WXesv {
        border-radius: 10px;
        width: 100px;
        height: 100px;
        background-color: #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.2s;
        overflow: hidden;

        &:hover {
            background-color: #e0e0e0;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 10px;
        }

        svg {
            width: 40px;
            height: 40px;
            fill: #666;
        }
    }

    .info_content_PUQJs {
        gap: 4px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;

        .info_content_title_n4nE9 {
            gap: 2px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;

            b {
                font-size: 22px;
                font-weight: 600;
                color: #000;
            }

            span {
                font-size: 14px;
                font-weight: 400;
                color: #000;
            }
        }

        .info_content_item_lmRQh {
            font-size: 14px;
            font-weight: 400;
            color: #000;
            display: inline-flex;
            flex-direction: column;
            gap: 2px;

            b {
                font-size: 14px;
                font-weight: 600;
                color: #000;
            }

            input {
                width: 100%;
                padding: 10px;
                background: var(--f5-background);
                border: none;
            }
        }

        .info_content_last_execution_cgfCA {
            font-size: 10px;
            font-weight: 400;
            color: #000;
        }
    }
}



.tabs_nTCns {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    div {
        width: 100%;
        /* height: 40px; */
        background-color: #f0f0f0;
        padding: 6px 10px;
        border-radius: 8px;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        /* min-width: 160px; */

        &:hover {
            background-color: #e0e0e0;
        }

        &.active_ieZdW {
            background-color: #10a37f;
            color: #ffffff;
        }
    }
}


.scrapping_G5m_n {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;

    .scrapping_text_EWrgJ {
        margin: 0px;
        font-size: 14px;
        font-weight: 400;
        color: #000;
    }

    .scrapping_progress_oevRp {
        width: 100%;
        height: 12px;
        background-color: #f0f0f0;
        padding: 4px;
        border-radius: 8px;
        overflow: hidden;
        margin: 0px;

        div {
            border-radius: 8px;
            width: 0%;
            height: 100%;
            background-color: #10a37f;
            transition: width 0.1s ease-out;
            position: relative;
        }
    }

    .scrapping_progress_text_lU_U6 {
        font-size: 12px;
        font-weight: 400;
        color: #000;
        z-index: 1;
    }

    .scrapping_text_content_container_GAOjQ {
        position: relative;
        width: 100%;
        margin-top: -18px;
        z-index: 0;

        &:after {
            content: "";
            display: block;
            height: 120%;
            width: 120%;
            /* background: red; */
            background: linear-gradient(to bottom, #ffffff 5%, #ffffff30 14%, #ffffffeb 66%, #fff 75%);
            position: absolute;
            top: 0px;
            left: 0px;
        }
    }

    .scrapping_text_content_LxOxm {
        width: 100%;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        color: #000;
        padding: 8px 18px;
        /* background: var(--f5-background); */
        border-radius: 10px;
        color: var(--1e293b-color);
        height: 320px;
        overflow-y: scroll;
        scroll-behavior: smooth;
        transition: all 0.3s ease;
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: 'Courier New', monospace;
        margin: 8px auto;



        &::-webkit-scrollbar {
            display: none;
        }
    }
}


.endpoints_iGA1f {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .endpoints_status_NGvgY {
        display: flex;
        /* flex-direction: column; */
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;

        .endpoints_status_item_Q3WC0 {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            background: #000000;
            padding: 6px 14px 6px 8px;
            border-radius: 30px;
            color: #fff;
            font-size: 12px;

            .endpoints_status_item_dot_GLSAJ {
                width: 10px;
                height: 10px;
                background-color: #000;
                border-radius: 50%;
            }
        }
    }

    .endpoints_list_container_tFslO {
        overflow: hidden;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border: 1px solid #e6e6e6;
        border-radius: 10px;
        width: 100%;

        .endpoints_list_aBO9w {
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #e6e6e6;
            width: 100%;

            .endpoints_list_item_ZeDpK {
                gap: 10px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                padding: 4px;

                button {
                    padding: 4px 10px;
                    border-radius: 6px;
                    background: var(--f5-background);
                    border: none;
                    cursor: pointer;
                    font-size: 12px;
                    text-transform: uppercase;
                    font-weight: 600;

                    &.ALL_Y3I2E {
                        background-color: #eeeeee;
                    }

                    &.POST_iKKkp {
                        background-color: #10a37f17;
                    }

                    &.PUT_f4jXa {
                        background-color: #f6851b17;
                    }

                    &.DELETE_C1dlI {
                        background-color: #c5221f17;
                    }
                }
            }
        }

        .endpoints_list_item_endpoint_Z66fE {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            width: 96%;
            border-bottom: 1px solid #e6e6e6;
            padding: 8px 20px;

            >div {
                margin-left: auto;
                display: inline-flex;
                gap: 10px;
            }
        }

        .endpoints_list_item_add_AmRIc {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            background: var(--f5-background);
            padding: 10px;
            cursor: pointer;
            font-weight: 500;

            &:hover {
                background-color: #f0f0f0;
            }
        }
    }
}



.params_yVRp9 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #e6e6e6;
    padding: 8px;
    gap: 8px;

    .params_title_TqGcF {
        font-size: 14px;
        font-weight: 600;
        color: #000;
    }

    .params_search_o4rtQ {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        width: 98%;
        padding: 10px;
        background: var(--f5-background);
        border-radius: 10px;
    }

    .params_list_XoKzy {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        gap: 16px;
        margin-top: 6px;

        .params_list_item_nmajQ {
            gap: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            width: 100%;

            svg {
                &:first-child {
                    margin-right: auto;
                }
            }
        }
    }
}





.test_M8Quo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .test_title_embCi {
        gap: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #000;
        display: inline-flex;
        flex-direction: column;
        width: 99%;
        padding: 10px;
        background: #fff;
        margin: 2px 12px 12px;

        b {
            font-size: 24px;
            font-weight: 600;
            color: #000;
            margin: 12px 0px 2px;
        }
    }

    .test_description_KD01K {
        font-size: 16px;
        line-height: 22px;
        font-weight: 400;
        color: #535353;
        margin: 0px;
        width: 100%;
    }

    .test_select_container_XBXKD {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        background: var(--f5-background);
        border-radius: 10px;
        padding: 2px 10px 2px 2px;

        .test_search_BcoIT {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 2px 10px;
            border-radius: 6px;
            gap: 8px;

            input {
                background: transparent;
                width: 100%;
                border: none;
                outline: none;
                padding: 6px;
                font-size: 12px;
            }
        }

        .test_select_MdPxw {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 4px 6px;
            font-size: 12px;
            font-weight: 600;
            background: var(--white-background);
            border-radius: 5px;
            line-height: 14px;
        }
    }

    .test_no_endpoints_W5uD1 {
        font-size: 10px;
        font-weight: 400;
        color: #000;
    }

    .test_endpoints_QiSGg {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        padding: 14px 16px 10px;
        border-top: 1px solid #e6e6e6;
        background: #fff;
        flex-direction: column;

        .test_endpoints_item_container_i6tSN {
            display: flex;
            flex-direction: row;
            gap: 10px;
            width: 100%;
            justify-content: space-between;

            .test_endpoints_item_wtBS6 {
                gap: 10px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                &.orange_VMtTv {
                    background-color: #ffa50026;
                    color: #f6851b;
                    padding: 2px 10px;
                    border-radius: 16px;
                    font-size: 12px;
                    font-weight: 500;
                }
            }
        }

        .test_endpoints_item_info_m4kSm {
            display: flex;
            /* flex-direction: column; */
            align-items: flex-start;
            justify-content: center;
            gap: 8px;

            label {
                font-size: 12px;
                font-weight: 400;
                color: #9b9b9b;
                margin: 0px;
                background: #f4f4f4;
                padding: 2px 6px;
                line-height: 14px;
            }
        }
    }

    /* .test_buttons {
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
        border-top: 1px solid #e6e6e6;

        .test_buttons_item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 10px;
            border-radius: 8px;
            font-size: 14px;
            text-align: center;
            cursor: pointer;
            background: #8A8A94;
            gap: 10px;
            color: #fff;
            font-weight: 700;
            padding: 8px 14px;

            &.green {
                background-color: #10a37f;
                color: #fff;

                &:hover {
                    background-color: #10a37f;
                }
            }

            &.gray {
                background-color: #e9e9ec;
                color: #4f5660;

                &:hover {
                    background-color: #e9e9ec;
                }
            }

            &:hover {
                background-color: #717171;
            }
        }

        .test_logs_title {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            padding: 10px;
            cursor: pointer;
        }
    } */

    .test_logs_QWDwO {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .test_logs_title_RPyyf {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        .test_logs_input_xyZAd {
            width: 100%;
            height: 40px;
            border: 1px solid #000;
        }
    }
}


.logs_RleK5 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .log_BjWt8 {
        background: #fff;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 10px;
        border-top: 1px solid #e6e6e6;

        .log_item_time_nVz5S {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            font-weight: 500;
        }

        .log_item_error_zLSQz {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 4px;
            color: #c5221f;
            font-size: 16px;
            font-weight: 500;
        }

        .log_item_testing_ZKYnX {

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        .log_item_success_aNKV9 {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

    }
}


.ALL_Y3I2E {
    font-size: 14px;
    font-weight: 400;
    color: #000;
}

.POST_iKKkp {
    font-size: 14px;
    font-weight: 400;
    color: #10a37f;
}

.PUT_f4jXa {
    font-size: 14px;
    font-weight: 400;
    color: #f6851b;
}

.DELETE_C1dlI {
    font-size: 14px;
    font-weight: 400;
    color: #c5221f;
}

@keyframes spin_CGlrR {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ApiPage/ApiPage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;IACtC,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,6BAA6B;IAC7B,uBAAuB;;;;IAIvB;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;;IAEnB;QACI,6BAA6B;QAC7B,uBAAuB;QACvB,kCAAkC;IACtC;;AAEJ;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;;;IAGhB;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;;QAET;YACI,WAAW;YACX,kBAAkB;YAClB,YAAY;YACZ,aAAa;YACb,YAAY;YACZ,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,WAAW;YACX,YAAY;YACZ,yBAAyB;YACzB,mBAAmB;YACnB,aAAa;YACb,YAAY;YACZ,oBAAoB;YACpB,mBAAmB;YACnB,uBAAuB;;YAEvB;gBACI,WAAW;gBACX,YAAY;YAChB;QACJ;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;;IAET;QACI,mBAAmB;QACnB,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,iCAAiC;QACjC,gBAAgB;;QAEhB;YACI,yBAAyB;QAC7B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;YACjB,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,UAAU;QACd;IACJ;;IAEA;QACI,QAAQ;QACR,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;;QAE9B;YACI,QAAQ;YACR,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,8BAA8B;;YAE9B;gBACI,eAAe;gBACf,gBAAgB;gBAChB,WAAW;YACf;;YAEA;gBACI,eAAe;gBACf,gBAAgB;gBAChB,WAAW;YACf;QACJ;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,WAAW;YACX,oBAAoB;YACpB,sBAAsB;YACtB,QAAQ;;YAER;gBACI,eAAe;gBACf,gBAAgB;gBAChB,WAAW;YACf;;YAEA;gBACI,WAAW;gBACX,aAAa;gBACb,gCAAgC;gBAChC,YAAY;YAChB;QACJ;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,WAAW;QACf;IACJ;AACJ;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET;QACI,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf,sBAAsB;;QAEtB;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;YACzB,cAAc;QAClB;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;;IAER;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;;QAEX;YACI,kBAAkB;YAClB,SAAS;YACT,YAAY;YACZ,yBAAyB;YACzB,+BAA+B;YAC/B,kBAAkB;QACtB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;QACjB,UAAU;;QAEV;YACI,WAAW;YACX,cAAc;YACd,YAAY;YACZ,WAAW;YACX,qBAAqB;YACrB,0FAA0F;YAC1F,kBAAkB;YAClB,QAAQ;YACR,SAAS;QACb;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,sCAAsC;QACtC,mBAAmB;QACnB,0BAA0B;QAC1B,aAAa;QACb,kBAAkB;QAClB,uBAAuB;QACvB,yBAAyB;QACzB,qBAAqB;QACrB,qBAAqB;QACrB,qCAAqC;QACrC,gBAAgB;;;;QAIhB;YACI,aAAa;QACjB;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;IAEvB;QACI,aAAa;QACb,4BAA4B;QAC5B,uBAAuB;QACvB,2BAA2B;QAC3B,QAAQ;;QAER;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,QAAQ;YACR,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YACnB,WAAW;YACX,eAAe;;YAEf;gBACI,WAAW;gBACX,YAAY;gBACZ,sBAAsB;gBACtB,kBAAkB;YACtB;QACJ;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,mBAAmB;QACnB,WAAW;;QAEX;YACI,gBAAgB;YAChB,aAAa;YACb,8BAA8B;YAC9B,gCAAgC;YAChC,WAAW;;YAEX;gBACI,SAAS;gBACT,aAAa;gBACb,mBAAmB;gBACnB,mBAAmB;gBACnB,2BAA2B;gBAC3B,YAAY;;gBAEZ;oBACI,iBAAiB;oBACjB,kBAAkB;oBAClB,gCAAgC;oBAChC,YAAY;oBACZ,eAAe;oBACf,eAAe;oBACf,yBAAyB;oBACzB,gBAAgB;;oBAEhB;wBACI,yBAAyB;oBAC7B;;oBAEA;wBACI,2BAA2B;oBAC/B;;oBAEA;wBACI,2BAA2B;oBAC/B;;oBAEA;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;QACJ;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,SAAS;YACT,UAAU;YACV,gCAAgC;YAChC,iBAAiB;;YAEjB;gBACI,iBAAiB;gBACjB,oBAAoB;gBACpB,SAAS;YACb;QACJ;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,WAAW;YACX,gCAAgC;YAChC,aAAa;YACb,eAAe;YACf,gBAAgB;;YAEhB;gBACI,yBAAyB;YAC7B;QACJ;IACJ;AACJ;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,QAAQ;;IAER;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,SAAS;QACT,UAAU;QACV,aAAa;QACb,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,uBAAuB;QACvB,WAAW;QACX,SAAS;QACT,eAAe;;QAEf;YACI,SAAS;YACT,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,2BAA2B;YAC3B,WAAW;;YAEX;gBACI;oBACI,kBAAkB;gBACtB;YACJ;QACJ;IACJ;AACJ;;;;;;AAMA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB;QACI,QAAQ;QACR,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,oBAAoB;QACpB,sBAAsB;QACtB,UAAU;QACV,aAAa;QACb,gBAAgB;QAChB,qBAAqB;;QAErB;YACI,eAAe;YACf,gBAAgB;YAChB,WAAW;YACX,oBAAoB;QACxB;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;QACT,gCAAgC;QAChC,mBAAmB;QACnB,yBAAyB;;QAEzB;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,iBAAiB;YACjB,kBAAkB;YAClB,QAAQ;;YAER;gBACI,uBAAuB;gBACvB,WAAW;gBACX,YAAY;gBACZ,aAAa;gBACb,YAAY;gBACZ,eAAe;YACnB;QACJ;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,gBAAgB;YAChB,eAAe;YACf,gBAAgB;YAChB,mCAAmC;YACnC,kBAAkB;YAClB,iBAAiB;QACrB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,8BAA8B;QAC9B,uBAAuB;QACvB,WAAW;QACX,uBAAuB;QACvB,6BAA6B;QAC7B,gBAAgB;QAChB,sBAAsB;;QAEtB;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,WAAW;YACX,8BAA8B;;YAE9B;gBACI,SAAS;gBACT,aAAa;gBACb,mBAAmB;gBACnB,mBAAmB;gBACnB,8BAA8B;;gBAE9B;oBACI,2BAA2B;oBAC3B,cAAc;oBACd,iBAAiB;oBACjB,mBAAmB;oBACnB,eAAe;oBACf,gBAAgB;gBACpB;YACJ;QACJ;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,uBAAuB;YACvB,uBAAuB;YACvB,QAAQ;;YAER;gBACI,eAAe;gBACf,gBAAgB;gBAChB,cAAc;gBACd,WAAW;gBACX,mBAAmB;gBACnB,gBAAgB;gBAChB,iBAAiB;YACrB;QACJ;IACJ;;IAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA2DG;;IAEH;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;;QAEvB;YACI,WAAW;YACX,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;QAClC;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,sBAAsB;QAC1B;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;;IAEtB;QACI,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;QACX,aAAa;QACb,6BAA6B;;QAE7B;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;YAC9B,QAAQ;YACR,cAAc;YACd,eAAe;YACf,gBAAgB;QACpB;;QAEA;;YAEI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;QAClC;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,8BAA8B;QAClC;;IAEJ;AACJ;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 100%;\n    /* overflow-y: auto; */\n    /* overflow-x: hidden; */\n    /* background: var(--f5-background); */\n    /* border-radius: 8px ; */\n    /* padding: 10px; */\n    /* overflow: hidden; */\n    background: transparent !important;\n    border-radius: 8px !important;\n    padding: 0px !important;\n\n\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n}\n\n.chat {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n    gap: 10px;\n    background: var(--fa-background);\n    height: fit-content;\n    overflow: hidden;\n    padding: 10px;\n    border-radius: 10px;\n\n    &.transparent {\n        border-radius: 0px !important;\n        padding: 0px !important;\n        background: transparent !important;\n    }\n\n}\n\n.scrap {\n    background-color: var(--f5-background);\n    border-radius: 10px;\n    padding: 4px 8px;\n\n\n    h1 {\n        font-size: 14px;\n        font-weight: 600;\n        color: #000;\n    }\n\n    .scrap_input {\n        width: 100%;\n        height: 40px;\n        display: inline-flex;\n        align-items: center;\n        gap: 10px;\n\n        input {\n            width: 100%;\n            /* height: 40px; */\n            border: none;\n            outline: none;\n            padding: 6px;\n            font-size: 16px;\n            font-weight: 500;\n        }\n\n        button {\n            cursor: pointer;\n            width: 30px;\n            height: 30px;\n            background-color: #10a37f;\n            border-radius: 10px;\n            padding: 10px;\n            border: none;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n\n            svg {\n                width: 12px;\n                height: 14px;\n            }\n        }\n    }\n}\n\n\n.info {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n\n    .info_img {\n        border-radius: 10px;\n        width: 100px;\n        height: 100px;\n        background-color: #f0f0f0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: background-color 0.2s;\n        overflow: hidden;\n\n        &:hover {\n            background-color: #e0e0e0;\n        }\n\n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            border-radius: 10px;\n        }\n\n        svg {\n            width: 40px;\n            height: 40px;\n            fill: #666;\n        }\n    }\n\n    .info_content {\n        gap: 4px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: space-between;\n\n        .info_content_title {\n            gap: 2px;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            justify-content: space-between;\n\n            b {\n                font-size: 22px;\n                font-weight: 600;\n                color: #000;\n            }\n\n            span {\n                font-size: 14px;\n                font-weight: 400;\n                color: #000;\n            }\n        }\n\n        .info_content_item {\n            font-size: 14px;\n            font-weight: 400;\n            color: #000;\n            display: inline-flex;\n            flex-direction: column;\n            gap: 2px;\n\n            b {\n                font-size: 14px;\n                font-weight: 600;\n                color: #000;\n            }\n\n            input {\n                width: 100%;\n                padding: 10px;\n                background: var(--f5-background);\n                border: none;\n            }\n        }\n\n        .info_content_last_execution {\n            font-size: 10px;\n            font-weight: 400;\n            color: #000;\n        }\n    }\n}\n\n\n\n.tabs {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n\n    div {\n        width: 100%;\n        /* height: 40px; */\n        background-color: #f0f0f0;\n        padding: 6px 10px;\n        border-radius: 8px;\n        font-size: 16px;\n        text-align: center;\n        cursor: pointer;\n        /* min-width: 160px; */\n\n        &:hover {\n            background-color: #e0e0e0;\n        }\n\n        &.active {\n            background-color: #10a37f;\n            color: #ffffff;\n        }\n    }\n}\n\n\n.scrapping {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 6px;\n\n    .scrapping_text {\n        margin: 0px;\n        font-size: 14px;\n        font-weight: 400;\n        color: #000;\n    }\n\n    .scrapping_progress {\n        width: 100%;\n        height: 12px;\n        background-color: #f0f0f0;\n        padding: 4px;\n        border-radius: 8px;\n        overflow: hidden;\n        margin: 0px;\n\n        div {\n            border-radius: 8px;\n            width: 0%;\n            height: 100%;\n            background-color: #10a37f;\n            transition: width 0.1s ease-out;\n            position: relative;\n        }\n    }\n\n    .scrapping_progress_text {\n        font-size: 12px;\n        font-weight: 400;\n        color: #000;\n        z-index: 1;\n    }\n\n    .scrapping_text_content_container {\n        position: relative;\n        width: 100%;\n        margin-top: -18px;\n        z-index: 0;\n\n        &:after {\n            content: \"\";\n            display: block;\n            height: 120%;\n            width: 120%;\n            /* background: red; */\n            background: linear-gradient(to bottom, #ffffff 5%, #ffffff30 14%, #ffffffeb 66%, #fff 75%);\n            position: absolute;\n            top: 0px;\n            left: 0px;\n        }\n    }\n\n    .scrapping_text_content {\n        width: 100%;\n        font-size: 16px;\n        line-height: 24px;\n        font-weight: 400;\n        color: #000;\n        padding: 8px 18px;\n        /* background: var(--f5-background); */\n        border-radius: 10px;\n        color: var(--1e293b-color);\n        height: 320px;\n        overflow-y: scroll;\n        scroll-behavior: smooth;\n        transition: all 0.3s ease;\n        white-space: pre-wrap;\n        word-wrap: break-word;\n        font-family: 'Courier New', monospace;\n        margin: 8px auto;\n\n\n\n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n}\n\n\n.endpoints {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .endpoints_status {\n        display: flex;\n        /* flex-direction: column; */\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 8px;\n\n        .endpoints_status_item {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            gap: 8px;\n            background: #000000;\n            padding: 6px 14px 6px 8px;\n            border-radius: 30px;\n            color: #fff;\n            font-size: 12px;\n\n            .endpoints_status_item_dot {\n                width: 10px;\n                height: 10px;\n                background-color: #000;\n                border-radius: 50%;\n            }\n        }\n    }\n\n    .endpoints_list_container {\n        overflow: hidden;\n        margin-top: 10px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        border: 1px solid #e6e6e6;\n        border-radius: 10px;\n        width: 100%;\n\n        .endpoints_list {\n            overflow: hidden;\n            display: flex;\n            justify-content: space-between;\n            border-bottom: 1px solid #e6e6e6;\n            width: 100%;\n\n            .endpoints_list_item {\n                gap: 10px;\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                justify-content: flex-start;\n                padding: 4px;\n\n                button {\n                    padding: 4px 10px;\n                    border-radius: 6px;\n                    background: var(--f5-background);\n                    border: none;\n                    cursor: pointer;\n                    font-size: 12px;\n                    text-transform: uppercase;\n                    font-weight: 600;\n\n                    &.ALL {\n                        background-color: #eeeeee;\n                    }\n\n                    &.POST {\n                        background-color: #10a37f17;\n                    }\n\n                    &.PUT {\n                        background-color: #f6851b17;\n                    }\n\n                    &.DELETE {\n                        background-color: #c5221f17;\n                    }\n                }\n            }\n        }\n\n        .endpoints_list_item_endpoint {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            gap: 10px;\n            width: 96%;\n            border-bottom: 1px solid #e6e6e6;\n            padding: 8px 20px;\n\n            >div {\n                margin-left: auto;\n                display: inline-flex;\n                gap: 10px;\n            }\n        }\n\n        .endpoints_list_item_add {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            width: 100%;\n            background: var(--f5-background);\n            padding: 10px;\n            cursor: pointer;\n            font-weight: 500;\n\n            &:hover {\n                background-color: #f0f0f0;\n            }\n        }\n    }\n}\n\n\n\n.params {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    border-radius: 10px;\n    border: 1px solid #e6e6e6;\n    padding: 8px;\n    gap: 8px;\n\n    .params_title {\n        font-size: 14px;\n        font-weight: 600;\n        color: #000;\n    }\n\n    .params_search {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 10px;\n        width: 98%;\n        padding: 10px;\n        background: var(--f5-background);\n        border-radius: 10px;\n    }\n\n    .params_list {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n        width: 100%;\n        gap: 16px;\n        margin-top: 6px;\n\n        .params_list_item {\n            gap: 10px;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: flex-start;\n            width: 100%;\n\n            svg {\n                &:first-child {\n                    margin-right: auto;\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n.test {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .test_title {\n        gap: 4px;\n        font-size: 14px;\n        font-weight: 400;\n        color: #000;\n        display: inline-flex;\n        flex-direction: column;\n        width: 99%;\n        padding: 10px;\n        background: #fff;\n        margin: 2px 12px 12px;\n\n        b {\n            font-size: 24px;\n            font-weight: 600;\n            color: #000;\n            margin: 12px 0px 2px;\n        }\n    }\n\n    .test_description {\n        font-size: 16px;\n        line-height: 22px;\n        font-weight: 400;\n        color: #535353;\n        margin: 0px;\n        width: 100%;\n    }\n\n    .test_select_container {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        gap: 10px;\n        background: var(--f5-background);\n        border-radius: 10px;\n        padding: 2px 10px 2px 2px;\n\n        .test_search {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            padding: 2px 10px;\n            border-radius: 6px;\n            gap: 8px;\n\n            input {\n                background: transparent;\n                width: 100%;\n                border: none;\n                outline: none;\n                padding: 6px;\n                font-size: 12px;\n            }\n        }\n\n        .test_select {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            padding: 4px 6px;\n            font-size: 12px;\n            font-weight: 600;\n            background: var(--white-background);\n            border-radius: 5px;\n            line-height: 14px;\n        }\n    }\n\n    .test_no_endpoints {\n        font-size: 10px;\n        font-weight: 400;\n        color: #000;\n    }\n\n    .test_endpoints {\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        align-items: flex-start;\n        width: 100%;\n        padding: 14px 16px 10px;\n        border-top: 1px solid #e6e6e6;\n        background: #fff;\n        flex-direction: column;\n\n        .test_endpoints_item_container {\n            display: flex;\n            flex-direction: row;\n            gap: 10px;\n            width: 100%;\n            justify-content: space-between;\n\n            .test_endpoints_item {\n                gap: 10px;\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                justify-content: space-between;\n\n                &.orange {\n                    background-color: #ffa50026;\n                    color: #f6851b;\n                    padding: 2px 10px;\n                    border-radius: 16px;\n                    font-size: 12px;\n                    font-weight: 500;\n                }\n            }\n        }\n\n        .test_endpoints_item_info {\n            display: flex;\n            /* flex-direction: column; */\n            align-items: flex-start;\n            justify-content: center;\n            gap: 8px;\n\n            label {\n                font-size: 12px;\n                font-weight: 400;\n                color: #9b9b9b;\n                margin: 0px;\n                background: #f4f4f4;\n                padding: 2px 6px;\n                line-height: 14px;\n            }\n        }\n    }\n\n    /* .test_buttons {\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 8px;\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        padding-top: 10px;\n        border-top: 1px solid #e6e6e6;\n\n        .test_buttons_item {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            padding: 10px;\n            border-radius: 8px;\n            font-size: 14px;\n            text-align: center;\n            cursor: pointer;\n            background: #8A8A94;\n            gap: 10px;\n            color: #fff;\n            font-weight: 700;\n            padding: 8px 14px;\n\n            &.green {\n                background-color: #10a37f;\n                color: #fff;\n\n                &:hover {\n                    background-color: #10a37f;\n                }\n            }\n\n            &.gray {\n                background-color: #e9e9ec;\n                color: #4f5660;\n\n                &:hover {\n                    background-color: #e9e9ec;\n                }\n            }\n\n            &:hover {\n                background-color: #717171;\n            }\n        }\n\n        .test_logs_title {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            gap: 10px;\n            padding: 10px;\n            cursor: pointer;\n        }\n    } */\n\n    .test_logs {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        .test_logs_title {\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n        }\n\n        .test_logs_input {\n            width: 100%;\n            height: 40px;\n            border: 1px solid #000;\n        }\n    }\n}\n\n\n.logs {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n\n    .log {\n        background: #fff;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        padding: 10px;\n        border-top: 1px solid #e6e6e6;\n\n        .log_item_time {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            font-size: 12px;\n            font-weight: 500;\n        }\n\n        .log_item_error {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            gap: 4px;\n            color: #c5221f;\n            font-size: 16px;\n            font-weight: 500;\n        }\n\n        .log_item_testing {\n\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n        }\n\n        .log_item_success {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n        }\n\n    }\n}\n\n\n.ALL {\n    font-size: 14px;\n    font-weight: 400;\n    color: #000;\n}\n\n.POST {\n    font-size: 14px;\n    font-weight: 400;\n    color: #10a37f;\n}\n\n.PUT {\n    font-size: 14px;\n    font-weight: 400;\n    color: #f6851b;\n}\n\n.DELETE {\n    font-size: 14px;\n    font-weight: 400;\n    color: #c5221f;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_pMIRk`,
	"chat": `chat_kYIvt`,
	"transparent": `transparent_sMqBU`,
	"scrap": `scrap_ROK0d`,
	"scrap_input": `scrap_input_Z2vD8`,
	"info": `info_XSDc8`,
	"info_img": `info_img_WXesv`,
	"info_content": `info_content_PUQJs`,
	"info_content_title": `info_content_title_n4nE9`,
	"info_content_item": `info_content_item_lmRQh`,
	"info_content_last_execution": `info_content_last_execution_cgfCA`,
	"tabs": `tabs_nTCns`,
	"active": `active_ieZdW`,
	"scrapping": `scrapping_G5m_n`,
	"scrapping_text": `scrapping_text_EWrgJ`,
	"scrapping_progress": `scrapping_progress_oevRp`,
	"scrapping_progress_text": `scrapping_progress_text_lU_U6`,
	"scrapping_text_content_container": `scrapping_text_content_container_GAOjQ`,
	"scrapping_text_content": `scrapping_text_content_LxOxm`,
	"endpoints": `endpoints_iGA1f`,
	"endpoints_status": `endpoints_status_NGvgY`,
	"endpoints_status_item": `endpoints_status_item_Q3WC0`,
	"endpoints_status_item_dot": `endpoints_status_item_dot_GLSAJ`,
	"endpoints_list_container": `endpoints_list_container_tFslO`,
	"endpoints_list": `endpoints_list_aBO9w`,
	"endpoints_list_item": `endpoints_list_item_ZeDpK`,
	"ALL": `ALL_Y3I2E`,
	"POST": `POST_iKKkp`,
	"PUT": `PUT_f4jXa`,
	"DELETE": `DELETE_C1dlI`,
	"endpoints_list_item_endpoint": `endpoints_list_item_endpoint_Z66fE`,
	"endpoints_list_item_add": `endpoints_list_item_add_AmRIc`,
	"params": `params_yVRp9`,
	"params_title": `params_title_TqGcF`,
	"params_search": `params_search_o4rtQ`,
	"params_list": `params_list_XoKzy`,
	"params_list_item": `params_list_item_nmajQ`,
	"test": `test_M8Quo`,
	"test_title": `test_title_embCi`,
	"test_description": `test_description_KD01K`,
	"test_select_container": `test_select_container_XBXKD`,
	"test_search": `test_search_BcoIT`,
	"test_select": `test_select_MdPxw`,
	"test_no_endpoints": `test_no_endpoints_W5uD1`,
	"test_endpoints": `test_endpoints_QiSGg`,
	"test_endpoints_item_container": `test_endpoints_item_container_i6tSN`,
	"test_endpoints_item": `test_endpoints_item_wtBS6`,
	"orange": `orange_VMtTv`,
	"test_endpoints_item_info": `test_endpoints_item_info_m4kSm`,
	"test_logs": `test_logs_QWDwO`,
	"test_logs_title": `test_logs_title_RPyyf`,
	"test_logs_input": `test_logs_input_xyZAd`,
	"logs": `logs_RleK5`,
	"log": `log_BjWt8`,
	"log_item_time": `log_item_time_nVz5S`,
	"log_item_error": `log_item_error_zLSQz`,
	"log_item_testing": `log_item_testing_ZKYnX`,
	"log_item_success": `log_item_success_aNKV9`,
	"spin": `spin_CGlrR`
};
export default ___CSS_LOADER_EXPORT___;
